import React from "react"
import { FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"
import Icon from "../../../icon/icon.component.jsx"

const ContactCreationButton = () => {
    return (
        <>
            <Link to="/imports/contacts" className="btn btn-outline-primary">
                <Icon value="download" />
                <FormattedMessage
                    id="generic-listing.import-btn-text"
                    defaultMessage="Import"
                />
            </Link>
            <Link to="/contacts/new" className="btn btn-primary">
                <Icon value="user-plus" />
                <FormattedMessage
                    id="generic-listing.contacts.create-btn-text"
                    defaultMessage="New contact"
                />
            </Link>
        </>
    )
}

export default ContactCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/ContactCreationButton.tsx